import * as React from 'react'
import { ReactElement } from 'react'
import useUnits from '../../../hooks/useUnits'
import { useFormikContext } from 'formik'
import EntityField, { EntityType } from './EntityField'
import { AccountingId } from '../../../config/finance/invoiceConfig'
import { EntityLabelType } from './EntityLabel'

type PivotValues = { [fieldName: string]: { [unitKey: string]: AccountingId } }

type Props = {
    fieldName: string
    externalType: EntityType
}

export default function MultiUnitEntityField({ fieldName, externalType }: Props): ReactElement {
    const { units } = useUnits()
    const {
        values: { [fieldName]: values },
        setFieldValue,
    } = useFormikContext<PivotValues>()

    return (
        <>
            {(units || []).map(unit => (
                <EntityField
                    key={unit.key}
                    unit={unit}
                    labelType={units.length > 1 ? EntityLabelType.Multiple : EntityLabelType.Single}
                    externalType={externalType}
                    value={values?.[unit.key]}
                    setFieldValue={(item: AccountingId) => setFieldValue(`${fieldName}.${unit.key}`, item)}
                />
            ))}
        </>
    )
}
